import { OnboardingStep } from '../../../../services/exports/Constants';

export default {
  [OnboardingStep.EmailVerification]: 'Confirmar dirección de correo',
  [OnboardingStep.BusinessInfo]: 'Añade los datos de tu tienda',
  [OnboardingStep.PersonalInfo]: 'Añade tu información personal',
  [OnboardingStep.ShippingInfo]: 'Añade tu información de entrega',
  [OnboardingStep.BankInfo]: 'Añade datos bancarios para cobros',
  [OnboardingStep.TaxInfo]: '¿Tu negocio está registrado en el IVA?',
  [OnboardingStep.BusinessDocs]: 'Documento acreditativo del negocio',
  [OnboardingStep.PersonalDocs]: 'Documento acreditativo de identidad',
  [OnboardingStep.InfoSubmission]: 'Recibir pagos',
  confirm_info_gateway: 'Recibir pagos – {{paymentGateway}}',
  [OnboardingStep.PaymentInfo]: 'Información de pago',
  [OnboardingStep.Subscription]: 'Suscripción',
  [OnboardingStep.MobileApp]: 'Aplicación móvil',
  [OnboardingStep.DeliveryStructure]: 'Estructura de entrega',
  [OnboardingStep.Contract]: 'Contrato',
  [OnboardingStep.ContractPayment]: 'Pago del contrato',
  [OnboardingStep.PromoCode]: 'Código promocional',
};
